// client/src/services/hubApi.js
// Public tenant hub, events embed and social proof (Growth Phase 8, base
// package). Staff calls go through services/http (session cookie); public
// calls never send credentials and never bounce to /login.

import { getJson, putJson } from './http';

const BASE = (process.env.REACT_APP_BASE_URL || '').replace(/\/+$/, '');
const APP_ORIGIN = (process.env.REACT_APP_BASE_URL || window.location.origin || '').replace(/\/+$/, '');

export const SECTION_KEYS = ['live', 'upcoming', 'past', 'actions', 'links', 'forms', 'socials'];
export const SOCIAL_PLATFORMS = ['instagram', 'facebook', 'x', 'tiktok', 'youtube', 'linkedin', 'threads', 'bluesky', 'pinterest'];
export const SOCIAL_PROOF_KEYS = ['going', 'entries', 'sellingFast', 'spotsLeft', 'attendees'];

// ---- staff ----
export const getHubSettings = (tenant) => getJson(`/api/tenants/${tenant}/hub-settings`);
export const saveHubSettings = (tenant, body) => putJson(`/api/tenants/${tenant}/hub-settings`, body);

// ---- share URLs ----
export const hubPageUrl = (tenantSlug) => `${APP_ORIGIN}/hub/${encodeURIComponent(tenantSlug)}`;
export const actionsPageUrl = (tenantSlug) => `${APP_ORIGIN}/hub/${encodeURIComponent(tenantSlug)}/actions`;

export function embedEventsUrl(tenantSlug, { view = 'list', limit = 10, theme = '' } = {}) {
  const q = new URLSearchParams({ view });
  if (view === 'list') q.set('limit', String(limit));
  if (theme) q.set('theme', theme);
  return `${APP_ORIGIN}/embed/${encodeURIComponent(tenantSlug)}/events?${q.toString()}`;
}

const attr = (s) => String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;');

/** iframe + the auto-resize script (served by the server at /embed/resize.js). */
export function embedSnippet(src, title = 'Events') {
  return `<iframe src="${attr(src)}" title="${attr(title)}" width="100%" height="480" style="border:0;width:100%;max-width:720px" loading="lazy"></iframe>\n<script src="${APP_ORIGIN}/embed/resize.js" async></script>`;
}

// ---- public ----
async function publicGet(path) {
  const res = await fetch(`${BASE}${path}`, { credentials: 'omit' });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || `${res.status}`);
    err.status = res.status;
    throw err;
  }
  return data;
}

const slug = (s) => encodeURIComponent(s);
export const fetchPublicHub = (tenantSlug) => publicGet(`/api/public/tenants/${slug(tenantSlug)}/hub`);
/** Open raffles + auctions across the tenant's public events (404 unless opted in). */
export const fetchPublicActions = (tenantSlug) => publicGet(`/api/public/tenants/${slug(tenantSlug)}/actions`);
export const fetchHubForms = (tenantSlug) => publicGet(`/api/forms/public/${slug(tenantSlug)}/hub`);
export const fetchSocialProof = (tenantSlug, eventSlug) =>
  publicGet(`/api/public/events/${slug(tenantSlug)}/${slug(eventSlug)}/social-proof`);
